import { gql } from "@apollo/client"

export const GET_PLATFORM_SETTINGS = gql`
  query getPlatformSettings($data: GetPlatformSettingsInput) {
    platformSettings {
      getPlatformSettings(data: $data) {
        defaultProgram
      }
    }
  }
`
